import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Step } from 'signup-constants/Step';
import TextAnimations from '../TextAnimations/TextAnimation';
import { useCopyCarousel } from '../app-active-loading/useCopyCarousel';
import { StyledH3 } from '../experiments/acq0143/ACQ0143TitleContainer';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { jsx as _jsx } from "react/jsx-runtime";
export const CarouselTitle = () => {
  const {
    copyToDisplay
  } = useCopyCarousel({
    baseI18n: `views.${Step.LandingPage}.acq143Title.title`,
    shouldGoRound: true,
    textSwitchingInterval: 5500
  });
  const message = isValidI18nKey(`views.${Step.LandingPage}.acq143Title.base_new`) ? `views.${Step.LandingPage}.acq143Title.base_new` : `views.${Step.LandingPage}.acq143Title.base`;
  return /*#__PURE__*/_jsx(StyledH3, {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: message,
      options: {
        useCase: /*#__PURE__*/_jsx(TextAnimations, {
          text: I18n.text(`${copyToDisplay}`)
        })
      }
    })
  });
};